
export default (str) => {
  if (str && str.length > 15) {
    return str.substring(0, 15) + '...'
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filters/maxLength_15.js